import * as fse from "fs-extra";
import { buildSliceDirectoryPath } from "./buildSliceDirectoryPath.js";
import { writeSliceModel } from "./writeSliceModel.js";
const renameSlice = async (args) => {
  const { model: existingModel } = await args.actions.readSliceModel({
    libraryID: args.libraryID,
    sliceID: args.model.id
  });
  await fse.move(await buildSliceDirectoryPath({
    ...args,
    model: existingModel,
    absolute: true
  }), await buildSliceDirectoryPath({
    ...args,
    absolute: true
  }));
  await writeSliceModel(args);
};
export {
  renameSlice
};
//# sourceMappingURL=renameSlice.js.map
